module.exports = __webpack_public_path__ + "media/images/mental-health-03929e65f43c4550b3450f6b764cffb1.svg";